// src/Pages/Rights.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Rights: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>
          Rights | Stockifly
        </title>

        <meta
          name="description"
          content="Rights of Stockifly"
        />
      </Helmet>

      <div className="rights-page">
        <header className="rights-header">
          <h1>{t('rights.title')}</h1>
        </header>

        <main className="rights-content">
          <section className="rights-section">
            <h2>{t('rights.terms.title')}</h2>
            <p>{t('rights.terms.text1')}</p>
            <p>{t('rights.terms.text2')}</p>
            <p>{t('rights.terms.text3')}</p>
          </section>

          <section className="rights-section">
            <h2>{t('rights.privacy.title')}</h2>
            <p>{t('rights.privacy.text1')}</p>
            <p>{t('rights.privacy.text2')}</p>
            <p>{t('rights.privacy.text3')}</p>
            <p>{t('rights.privacy.text4')}</p>
          </section>

          <section className="rights-section">
            <p className='rights-link'>
              {t('rights.backToHome')} <Link to="/">{t('rights.home')}</Link>
            </p>
          </section>
        </main>
      </div>
    </>
  );
};

export default Rights;